'use client';

import {Card, Layout} from "antd";
import React, {useState} from "react";
import {LoginRequest} from "@/lib/definitions-requests";
import {changeUserPassword, loginUser} from "@/services/account-service";
import {useRouter, useSearchParams} from "next/navigation";
import {Content} from "antd/es/layout/layout";
import AccountLoginForm from "@/components/pages/account/AccountLoginForm";
import AccountPageTitle from "@/components/pages/account/AccountPageTitle";
import ChangePasswordForm from "@/components/pages/account/ChangePasswordForm";

const AccountLoginPageClient = () => {
    const [pageTitle, setPageTitle] = useState<string>("Авторизация");
    const [userId, setUserId] = useState<string | null>(null);
    const [login, setLogin] = useState<string | null>(null);
    const [password, setPassword] = useState<string | null>(null);
    const router = useRouter();
    const searchParams = useSearchParams();

    const returnUrlParam = searchParams.get("returnUrl");
    const returnUrl = returnUrlParam && returnUrlParam.startsWith("/") && !returnUrlParam.startsWith("//") && !returnUrlParam.startsWith("/account/login")
        ? returnUrlParam
        : "/";

    const handleLogin = async () => {
        if (!login || !password) {
            return;
        }

        const request: LoginRequest = {
            login,
            password
        };

        await loginUser(request)
            .then(response => {
                if (response === null) {
                    return;
                }

                if (response.status === 200) {
                    router.push(returnUrl);
                    return;
                }

                if (response.status === 403 && response.data._links?.setPassword) {
                    console.log(response.data._links?.setPassword.href.split("/").at(-1));
                    setUserId(response.data._links?.setPassword.href.split("/").at(-1));
                    setPageTitle("Установка пароля");
                    return;
                }
            });
    };

    const handleSavePassword = async () => {
        if (!userId || !password) {
            return;
        }

        await changeUserPassword(userId, password)
            .then(statusCode => {
                if (statusCode === 204) {
                    router.push(returnUrl);
                    return;
                }
            });
    };

    return (
        <Layout style={{minHeight: "100vh"}}>
            <Content style={{minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
                <Card style={{width: 500, padding: "24px 16px"}}>
                    <AccountPageTitle title={pageTitle}/>
                    {
                        userId === null ?
                            <AccountLoginForm setLogin={setLogin}
                                              setPassword={setPassword}
                                              handleLogin={handleLogin}/> :
                            <ChangePasswordForm setPassword={setPassword}
                                                handleSavePassword={handleSavePassword}/>
                    }
                </Card>
            </Content>
        </Layout>
    );
};

export default AccountLoginPageClient;
